export let HOST_URL_WEB = `http://121.61.250.38:1110/` //前端服务器

// 后端服务地址配置
export const BACKEND_URLS = {
  // 主后端服务（9999端口）- 处理 /jsqm 和 /soil 路径
  main: 'http://120.78.202.98:9999',
  // 另一个后端服务（18089端口）- 处理 /api 路径
  api: 'http://120.78.202.98:18089'
}

// axios配置
export let AXIOS_CONFIG = {
  baseURL: {
    dev: 'http://localhost:8080', // 开发环境使用本地代理（vue.config.js）
    test: `${HOST_URL_WEB}`,
    // 生产环境：根据请求路径动态选择后端地址
    // 在 request.js 中会根据路径前缀自动选择正确的后端地址
    prod: '' // 设置为空，由请求拦截器动态设置
  }
}


// export let HOST_URL_WEB = `http://121.61.250.38:1110/` //前端服务器

// // axios配置
// export let AXIOS_CONFIG = {
//   baseURL: {
//     dev: 'http://localhost:8080',
//     test: `${HOST_URL_WEB}`,
//     prod: `${HOST_URL_WEB}`
//   }
// }